export default __webpack_public_path__ + "static/media/Screenshot.e2ca5bdc.png";